import * as types from './actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';
import store from 'redux/store';
import {
  GET_ALL_USER_HAS_KAT_ADDRESS,
  GET_ALL_USER_HAS_KAT_ADDRESS_SUCCESS,
  GET_ALL_USER_HAS_KAT_ADDRESS_FAILED,
  GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE,
  GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE_SUCCESS,
  GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE_FAILED,
  SEND_EMAIL_TO_DEV_PARTNER,
  SEND_EMAIL_TO_DEV_PARTNER_OK,
  SEND_EMAIL_TO_DEV_PARTNER_FAIL,
} from './actionTypes';

export const getAllUserHasKatAddress = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_USER_HAS_KAT_ADDRESS });
    const response = await client.api('/users-have-kat-address', 'get', {
      headers: await cognito.getHeaderAuthorization(),
    });
    dispatch({
      type: GET_ALL_USER_HAS_KAT_ADDRESS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_ALL_USER_HAS_KAT_ADDRESS_FAILED,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const getEmailsByWalletAddressesInLPSale = (walletAddresses) => async (dispatch) => {
  try {
    dispatch({ type: GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE });

    const response = await client.api(
      '/get-email-by-wallet-addressin-lp-sale',
      'post',
      { buyerAddresses: walletAddresses },
      { headers: await cognito.getHeaderAuthorization() },
    );

    dispatch({
      type: GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    console.error('Error in getEmailsByWalletAddressesInLPSale:', error);
    console.error('Error response:', error.response);
    dispatch({
      type: GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE_FAILED,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const sendEmailToDevPartner = async (daoId, txHash, milestoneAmount) => {
  const response = await client.api(
    '/dao-service/send-email-dev-partner-claim-instruction',
    'post',
    {
      daoId,
      txHash,
      milestoneAmount,
    },
    {
      headers: await cognito.getHeaderAuthorization(),
    },
  );

  return response.data;
};

export const getCodebasesByDaoId = (daoId) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_CODEBASES_BY_DAO_ID' });
    const response = await client.api(`/codebase/get-codebases-by-dao?daoId=${daoId}`, 'get', {
      headers: await cognito.getHeaderAuthorization(),
      provider: 'CognitoUserPool',
      'Content-Type': 'application/json',
    });
    dispatch({ type: 'GET_CODEBASES_BY_DAO_ID_SUCCESS', payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({
      type: 'GET_CODEBASES_BY_DAO_ID_FAIL',
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const getVestingAddressesByDaoId = (daoId) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_VESTING_ADDRESSES_BY_DAO_ID' });
    const response = await client.api(`/sale/get-vesting-addresses-by-daoId?daoId=${daoId}`, 'get', {
      headers: await cognito.getHeaderAuthorization(),
      provider: 'CognitoUserPool',
      'Content-Type': 'application/json',
    });
    dispatch({
      type: 'GET_VESTING_ADDRESSES_BY_DAO_ID_SUCCESS',
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: 'GET_VESTING_ADDRESSES_BY_DAO_ID_FAIL',
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const getVestingAllocationsSummaryByVestingAddress = (vestingAddress) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_VESTING_ALLOCATIONS_SUMMARY_BY_VESTING_ADDRESS' });
    const response = await client.api(`/vesting/${vestingAddress}/allocations-summary`, 'get', {
      headers: await cognito.getHeaderAuthorization(),
      provider: 'CognitoUserPool',
      'Content-Type': 'application/json',
    });
    dispatch({
      type: 'GET_VESTING_ALLOCATIONS_SUMMARY_BY_VESTING_ADDRESS_SUCCESS',
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: 'GET_VESTING_ALLOCATIONS_SUMMARY_BY_VESTING_ADDRESS_FAIL',
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};
